import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import Home from "../home/Home";
import Session from "../sessions/Session";

if (process.env.REACT_APP_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    appVersion: "0.1.5",
  });
}

const ErrorBoundary = Bugsnag.getPlugin("react")?.createErrorBoundary(React);

const App = () => {
  if (!ErrorBoundary) {
    return null;
  }
  return (
    <ErrorBoundary>
      <BrowserRouter basename="/venue">
        <div className="App">
          <Switch>
            <Route exact path="/:venueId">
              <LoadingScreen>
                <Home />
              </LoadingScreen>
            </Route>
            <Route path="/:venueId/session/:sessionId">
              <LoadingScreen>
                <Session />
              </LoadingScreen>
            </Route>
          </Switch>
        </div>
      </BrowserRouter>
      <style global jsx>{`
        html {
          font-family: "Avenir", "Segoe UI", "Helvetica", "Arial", "sans-serif",
            "Apple Color Emoji", "Segoe UI Emoji";
          margin: 0;
          overflow: hidden;
          box-sizing: border-box;
        }
        *,
        *:before,
        *:after {
          box-sizing: inherit;
        }
      `}</style>
    </ErrorBoundary>
  );
};

export default App;
